import { useEffect, useState } from 'react';
import { CONTACT, NAV_LINKS } from '../content';
import Logo from './Logo';
import { Close, Menu } from './Icons';
import './Nav.css';

// The bar adapts to whatever section sits beneath it: sections declare
// data-nav="over" (photo), "dark" or "light".
export default function Nav() {
  const [tone, setTone] = useState('over');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let raf = 0;
    const probe = () => {
      raf = 0;
      let next = 'dark';
      for (const el of document.querySelectorAll('[data-nav]')) {
        const r = el.getBoundingClientRect();
        if (r.top <= 34 && r.bottom > 34) {
          next = el.dataset.nav;
          break;
        }
      }
      if (next === 'over' && window.scrollY > 24) next = 'dark';
      setTone(next);
    };
    const onScroll = () => {
      if (!raf) raf = requestAnimationFrame(probe);
    };
    probe();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    document.addEventListener('keydown', onKey);
    document.documentElement.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.documentElement.style.overflow = '';
    };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <header className={`nav nav--${open ? 'dark' : tone}${open ? ' is-open' : ''}`}>
      <div className="nav__inner">
        <a href="#top" className="nav__brand" aria-label="Average Quality — back to top" onClick={close}>
          <Logo />
        </a>
        <nav className="nav__links" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
        </nav>
        <div className="nav__actions">
          <a className="nav__text-link" href={`mailto:${CONTACT.email}`}>
            Email us
          </a>
          <a className="btn btn-primary btn-sm nav__cta" href="#contact">
            Start a project
          </a>
          <button
            type="button"
            className="nav__toggle"
            aria-expanded={open}
            aria-controls="nav-sheet"
            onClick={() => setOpen((o) => !o)}
          >
            {open ? <Close /> : <Menu />}
            <span className="sr-only">{open ? 'Close menu' : 'Open menu'}</span>
          </button>
        </div>
      </div>

      <div id="nav-sheet" className="nav__sheet" hidden={!open}>
        {NAV_LINKS.map((link) => (
          <a key={link.href} href={link.href} className="nav__sheet-link" onClick={close}>
            {link.label}
          </a>
        ))}
        <a className="btn btn-primary" href="#contact" onClick={close}>
          Start a project
        </a>
        <a className="nav__sheet-mail mono" href={`mailto:${CONTACT.email}`}>
          {CONTACT.email}
        </a>
      </div>
    </header>
  );
}
